import { ReactNode } from 'react'

import '../../styles/documents-findings-details-management.css'

const CustomerDetailsPaymentDetailsDataTableRow = ({ icon, rowName, rowValue, lastValue }: { icon: ReactNode; rowName: string; rowValue: string | ReactNode; lastValue?: boolean }) => {
  return (
    <div className={lastValue ? 'document-finding-data-table-row-container-last' : 'document-finding-data-table-row-container'}>
      <div className="document-finding-data-table-row-item">
        {icon}
        <div className="document-finding-data-table-row-item-name">{rowName}</div>
      </div>
      <div className="document-finding-data-table-row-item">
        <div className={typeof rowValue === 'string' ? 'document-finding-data-table-row-item-value' : 'document-finding-data-table-row-item-value-component'}>{rowValue}</div>
      </div>
    </div>
  )
}

export default CustomerDetailsPaymentDetailsDataTableRow
